import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { SecondaryButton } from '../ClickableComponents/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadMore = ({
  onClick
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(LinkContainer, {
    children: /*#__PURE__*/_jsx(StyledSecondaryButton, {
      type: "text",
      text: t('global.loadMore'),
      onClick: onClick,
      expand: true
    })
  });
};
const LinkContainer = styled.div.withConfig({
  displayName: "LoadMore__LinkContainer",
  componentId: "sc-1m7lrrf-0"
})(["margin-top:32px;display:grid;justify-content:center;", "{display:block;}"], Viewports.for('small'));
const StyledSecondaryButton = styled(SecondaryButton).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "LoadMore__StyledSecondaryButton",
  componentId: "sc-1m7lrrf-1"
})(["padding:8px 40px;"]);